import { BasicDto, IdObject } from '../../_shared/models/basicDto';
import { PersonWithContact } from '../../person/models/person';

export interface AddressMemberList extends IdObject<number> {
  Address: AddressList;
  AddressId: number | null;
  PersonId: number | null;
}

export class PersonXAddressBasic implements IdObject<number> {
  constructor() {
    this.Id = 0;
    this.AddressId = null;
    this.PersonId = null;
    this.AddressMemberTypeId = null;
    this.SendPost = null;
    this.IsHidden = null;
  }

  Id: number;
  AddressId: number | null;
  PersonId: number | null;
  AddressMemberTypeId: number | null;
  SendPost: boolean | null;
  IsHidden: boolean | null;
}

export interface PersonXAddressExport extends PersonXAddressBasic {
  Address: AddressList;
}

export class PersonXAddressList extends PersonXAddressBasic {
  Address: AddressWithPersons | undefined;
}

export interface AddressXPersonList extends PersonXAddressBasic {
  Person: PersonWithContact;
  //TODO AddressMemberType: AddressMemberTypeList;
}

export class AddressList implements BasicDto<number> {
  constructor() {
    this.Id = 0;
    this.AddressTypeId = 4;
    this.MatchScore = 0;
  }

  Id: number;
  OrganizationId!: number | null;
  AddressTypeId!: number | null;
  Name!: string;
  NameTicket!: string;
  Street!: string;
  StreetWithNr!: string;
  Nr!: string;
  Bus!: string;
  PostCode!: string;
  Location!: string;
  Province!: string;
  GSM!: string;
  HomePhone!: string;
  Email!: string;
  Website!: string;
  Country!: string;
  Fax!: string;
  JuridicStatuteId!: number | null;
  Building!: string;
  IsSwimmingPool!: boolean | null;
  Family!: boolean | null;
  AddressGroupId!: number | null;
  Short!: string;
  MoreInformation!: string;
  AccountNumber!: string;
  Iban!: string;
  Bic!: string;
  FollowNumber!: string;
  EnterpriseNumber!: string;
  customJuridicStatute!: string;
  IsUsedForCompetitions!: boolean | null;
  LengthOfPool!: string;
  DateOfLastExamination!: Date | null;
  Gewest!: string;
  Latitude!: number | null;
  Longitude!: number | null;
  VatNumber!: string;
  MatchScore!: number | null;
  ExternalId!: string;
}

export interface Address extends AddressList {
  Disabled: boolean;
}

export interface AddressWithPersons extends Address {
  PersonXAddresses: AddressXPersonList[];
}
